<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col
        cols="12"
        md="4"
        lg="3"
        v-for="(checkbox, index) in subRolesList"
        :key="index"
        class="py-0"
      >
        <v-checkbox
          class="margin-top-checkbox mb-md-4 mb-3"
          :label="checkbox.name"
          v-model="roles"
          :value="checkbox.id"
          hide-details="auto"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>First Name</translate></label>
        <v-text-field
          class="field-custom"
          v-model="formData.firstName"
          :rules="emptyRules"
          outlined
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Last Name</translate></label>
        <v-text-field
          class="field-custom"
          v-model="formData.lastName"
          :rules="emptyRules"
          outlined
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Phone</translate></label>
        <v-text-field
          class="field-custom"
          v-model="formData.phone"
          :rules="emptyRules"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Country</translate></label>
        <v-autocomplete
          class="field-custom"
          v-model="formData.country"
          :items="countryList"
          :placeholder="$gettext('Select country')"
          item-value="id"
          item-text="name"
          return-object
          outlined
          clearable
          @change="changeCountry"
        >
          <template v-slot:item="{ item }">
            <CountryFlag
              :icon="item.id.toLowerCase()"
              marginRight="margin-right-10"
            />
            {{ item.name }}
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm">
          <translate>State/Region/Province</translate>
        </label>
        <v-autocomplete
          class="field-custom"
          v-model="stateSelect"
          :items="stateList"
          :placeholder="$gettext('Select state/region/province')"
          item-value="name"
          item-text="name"
          return-object
          outlined
          clearable
          @change="changeState"
          :disabled="!stateList.length"
        >
          <template v-slot:item="{ item }">
            <span class="capitalizeText">{{ item.name }}</span>
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>City</translate></label>
        <v-autocomplete
          class="field-custom"
          v-model="citySelect"
          :items="cityList"
          :placeholder="$gettext('Select city')"
          item-value="name"
          item-text="name"
          return-object
          outlined
          clearable
          :disabled="!cityList.length"
        >
          <template v-slot:item="{ item }">
            <span class="capitalizeText">{{ item.name }}</span>
          </template>
          <template slot="no-data">
            <translate class="ml-3">No data available</translate>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Language</translate></label>
        <AutocompleteLimit v-model="langSelect" :items="countryLang" dense />
      </v-col>
      <v-col cols="12" :md="4" class="py-0">
        <label class="titleForm"><translate>Handicap</translate></label>
        <v-text-field
          class="field-custom field-handicap"
          v-model="handicapVal"
          outlined
          type="number"
          max="54"
          min="-20"
          step="0.1"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" class="mb-4" v-if="!hideSubmit">
        <v-btn
          large
          @click="$emit('cancel')"
          class="font-weight-bold elevation-0 text-none subtitle-1 mr-3"
        >
          <translate>Cancel</translate>
        </v-btn>
        <v-btn
          large
          type="submit"
          color="primary"
          @click.prevent="onSubmit"
          class="font-weight-bold elevation-0 text-none subtitle-1"
        >
          <translate>Save</translate>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import CountryFlag from "@/components/CountryFlag";
import AutocompleteLimit from "@/components/Forms/AutocompleteLimit";
import { toFixedNumber } from "@/utils/helper";
import Vue from 'vue';
export default {
  props: [
    "firstName",
    "lastName",
    "phone",
    "countryData",
    "city",
    "state",
    "handicap",
    "subRoles",
    "subRolesList",
    "hideSubmit",
  ],
  directives: { mask },
  components: { CountryFlag, AutocompleteLimit },
  data() {
    return {
      valid: true,
      emptyRules: [
        (v) => !!v || Vue.prototype.$gettext("Field is required"),
        (v) => (v && v.length <= 15) || Vue.prototype.$gettext("Field must be less than 15 characters"),
      ],
      showInput: false,
      roles: [],
      langSelect: [],
      handicapVal: 0,
      citySelect: null,
      cityList: [],
      stateSelect: null,
      stateList: [],
    };
  },
  computed: {
    ...mapState("location", {
      languages: "languages",
      countryLang: "countryLang",
      countryList: "countryList",
    }),
    formData() {
      let data = {
        languages: this.langSelect.map((item) => item.id),
        firstName: this.firstName || "",
        lastName: this.lastName || "",
        phone: this.phone || "",
        country: this.countryData || {},
        handicap: this.handicapVal || 0,
      };
      return data;
    },
  },
  watch: {
    handicapVal(val) {
      if (val > 54) {
        this.$nextTick(() => {
          this.handicapVal = 54;
        });
      }
      if (val < -20) {
        this.$nextTick(() => {
          this.handicapVal = -20;
        });
      }
    },
    subRoles: {
      immediate: true,
      handler(val) {
        this.roles = [...val];
      },
    },
    languages: {
      immediate: true,
      handler(val) {
        this.langSelect = [...val];
      },
    },
  },
  methods: {
    onSubmit() {
      let vm = this;
      if (vm.$refs.form.validate()) {
        let data = { ...vm.formData };
        let stateSelect = vm.stateSelect || {};
        let citySelect = vm.citySelect || {};
        data.handicap = toFixedNumber(data.handicap, 1);
        data.state = stateSelect.name;
        data.city = citySelect.name;
        data.subRoles = vm.roles;
        vm.$emit("submit", { type: "infomation", data: data });
        vm.$store.commit("location/SET_CURRENT_LOCATION", {
          country: data.country,
          region: data.state,
          city: data.city,
          languages: vm.langSelect,
        });
        return true;
      } else {
        return false;
      }
    },
    async setStateList(id) {
      this.stateList = await this.$store.dispatch(
        "location/getStateLocation",
        id
      );
    },
    async setCityList(id) {
      this.cityList = await this.$store.dispatch(
        "location/getCityLocation",
        id
      );
    },
    async changeCountry(val) {
      if (val) {
        await this.setStateList(val.id);
      } else {
        this.stateList = [];
        this.cityList = [];
      }
    },
    async changeState(val) {
      if (val) {
        await this.setCityList(val.id);
      } else {
        this.cityList = [];
      }
    },
  },
  async mounted() {
    this.handicapVal = parseFloat(this.handicap);
    if (this.state) {
      this.stateList = [{ id: this.state, name: this.state }];
      this.stateSelect = { id: this.state, name: this.state };
    }
    if (this.city) {
      this.cityList = [{ id: this.city, name: this.city }];
      this.citySelect = { id: this.city, name: this.city };
    }
    if (this.countryData) await this.setStateList(this.countryData.id);
  },
};
</script>